import React, { useEffect, useRef, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  totalHkRequestsSelector,
  fetchTotalHkRequests,
  hkServiceDetailsSelector,
  fetchHKServiceDetails,
  hkServiceDetailsFilterSelector,
  fetchHKServiceFilterDetails,
  fetchHKServiceActivityDetailsList,
  hkActivityListSelector,
} from '../AnalyticsSlice';
import moment from 'moment';
import CardWrapper from '../CardWrapper';
import {
  generatePdfTable,
  generateTotalReservationExportData,
  generateChartPdfExportData,
} from '../../../utils/analyticUtils';
import './housekeeping.scss';
import SummaryCardWrapper from '../SummaryCardWrapper';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
//temporarily disable
// import zc from "@dvsl/zoomcharts";
import WidgetWrapper from '../WidgetWrapper';
import ImageCard from '../ImageCard';
import { ASSET_URL } from '../../../env/Configurations';
import TablePaginationActions from '../../../shared/table-pagination/TablePaginationActions';
import HouseKeepingPreviewPopup from '../HouseKeepingPreviewPopup';
import CustomPieChart from '../../../shared/charts/custom-pie-chart/CustomPieChart';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import ServiceRequest from '../../statistics/service-request/ServiceRequest';
import { decryptLocalStorage } from '../../../utils/authUtils';
import { statisticsDataKeys } from '../Analytics';
import { filteredHotelsSelector, selectedHotelSelector } from '../../property/propertySlice';
import { getSelectedHotelName } from '../../../utils/commonUtils';

const Housekeeping = (props) => {
  const {
    startDate,
    endDate,
    hotelId,
    showAllForReport = false,
    showLoader = () => {},
    setShowAllForReport = () => {},
  } = props;
  const dispatch = useDispatch();
  const hkServiceDetails = useSelector(hkServiceDetailsSelector);
  const fetchHKServiceFilter = useSelector(hkServiceDetailsFilterSelector);
  const totalHkRequestsData = useSelector(totalHkRequestsSelector);
  const hkActivityList = useSelector(hkActivityListSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const selectedHotelList = useSelector(filteredHotelsSelector);
  const [isPreview, setIsPreview] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [isHideExpand, setIsHideExpand] = useState(false);
  const [reservationChartData, setReservationChartData] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  //temporarily disabless
  // let TimeChart = zc.TimeChart;
  // let PieChart = zc.PieChart;

  const [showNoData, setShowNoData] = useState(false);
  const parentElement = useRef(null);

  const updateDataAvailability = () => {
    parentElement.current = document?.getElementById('house-keeping-analytics');

    if (parentElement?.current?.childNodes?.length <= 0) {
      setShowNoData(true);
    } else {
      setShowNoData(false);
    }
  };

  const currentHotelName = getSelectedHotelName(selectedHotelList, selectedHotel);

  const currency = totalHkRequestsData?.currencyCode;

  useEffect(() => {
    onFetchHKServiceData();
    onFetchTotalHkRequestData();
    onFetchHKServiceFilterData();
    onFetchHKActivityListData();
    updateDataAvailability();
  }, [hotelId, startDate, endDate, decryptLocalStorage('lang')]);

  const epoch = (date) => {
    return moment(date).unix();
  };

  useEffect(() => {
    if (totalHkRequestsData && totalHkRequestsData?.dailyTotal?.values) {
      let totalHkRequestsDataBeforeSort = JSON.parse(totalHkRequestsData?.dailyTotal?.values);

      let tempEndDate = new Date(endDate);

      setReservationChartData(
        totalHkRequestsDataBeforeSort
          ?.sort((a, b) => a?.[0] - b?.[0])
          ?.map((element, index) => {
            return {
              [statisticsDataKeys?.date]: moment(new Date(element?.[0]) * 1000)?.format(
                statisticsDataKeys?.dateFormat,
              ),
              y: element[1],
              Requests: element[1],
            };
          }),
      );
    }

    updateDataAvailability();
  }, [totalHkRequestsData]);

  useEffect(() => {
    if (hkServiceDetails && hkServiceDetails?.categoryPieChartData) {
      let categoryPieChartData = JSON.parse(hkServiceDetails?.categoryPieChartData);

      const data = {
        subvalues: categoryPieChartData.map((category) => ({
          name: category?.name,
          value: category?.value,
          subvalues: category?.subvalues?.map((subvalue) => ({
            name: subvalue?.name,
            value: subvalue?.value,
          })),
        })),
      };

      setPieChartData(
        categoryPieChartData?.map((element, index) => {
          return {
            label: element?.name,
            name: element?.name,
            value: element?.value,
            valueWithPercent: element?.value.toString().concat('%'),
            count: element?.count,
          };
        }),
      );
    }

    updateDataAvailability();
  }, [hkServiceDetails]);

  const formatPieChartTooltip = (datum) => ({
    name: 'Count',
    value: `${datum?.count}`,
  });

  const onClickPieChart = (events, data) => {
    const currentValue = data?.slice?.data?.name?.toUpperCase();
    onFetchHKServiceFilterData(currentValue);
  };
  const onSelectionChange = (data) => {
    let temp = false;
    if (!data) {
      temp = false;
      setSelectedCategory('');
    } else if (data) {
      if (data?.slice?.selected) {
        setSelectedCategory(`of ${data?.slice?.data?.name}`);
      } else {
        setSelectedCategory('');
        onFetchHKServiceFilterData();
      }
      temp = data?.slice?.selected;
    }
    setIsHideExpand(temp);
  };

  const infoContents = (data) => {
    let info = '<div>';

    if (data?.name) {
      info +=
        "<p style='padding:10px 10px 0px 10px; text-align: center; font-weight: bold; border-bottom: 1px solid #333'>" +
        data.name +
        '</p>';
    } else {
      info +=
        "<p style='padding:10px 10px 0px 10px; text-align: center; font-weight: bold; border-bottom: 1px solid #333'>NA</p>";
    }

    if (data.value) {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'>Total Requests: </span><span style='padding: 0px 5px 0px 5px; color: #333'>" +
        data.value +
        '</span > </p>';
    } else {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'> Total Requests: </span><span style='padding: 0px 5px 0px 5px;color: #333'> NA </span > </p>";
    }

    return info;
  };

  const onFetchHKServiceData = (categoryType = '') => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      lang: language,
      categoryType,
    };
    dispatch(fetchHKServiceDetails(payload));
  };

  const onFetchHKServiceFilterData = (categoryType = '') => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      lang: language,
      categoryType,
    };
    dispatch(fetchHKServiceFilterDetails(payload));
  };

  const onFetchHKActivityListData = () => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      lang: language,
    };
    dispatch(fetchHKServiceActivityDetailsList(payload));
  };

  const onFetchTotalHkRequestData = (option) => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(fetchTotalHkRequests(payload));
  };

  const addWaterMark = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(150);
      doc.setTextColor('#E5E5E5');
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.5 }));
      doc.text('Hudini', 50, doc.internal.pageSize.height - 50, {
        angle: 45,
      });
      doc.restoreGraphicsState();
    }

    return doc;
  };

  const addPageNumber = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(12);
      doc.setTextColor('#00000');
      doc.text(100, doc.internal.pageSize.height - 5, `${i} of ${totalPages}`);
    }

    return doc;
  };

  const generateTotalReservationPdf = () => {
    let body = [];
    let header = ['Date', 'Requests'];
    if (totalHkRequestsData && totalHkRequestsData?.dailyTotal?.values) {
      let tempData = JSON.parse(totalHkRequestsData?.dailyTotal?.values);
      body = generateChartPdfExportData(tempData);
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);

    const titleText = 'HOUSEKEEPING';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);

    const subTitleText = 'Requests';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc
      .text(70, 50, moment().format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc
      .text(70, 55, moment(startDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc
      .text(70, 60, moment(endDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');

    doc.setFont(undefined, 'normal').text(20, 70, 'Total Requests:').setFont(undefined, 'normal');
    doc
      .setFont(undefined, 'normal')
      .text(70, 70, totalHkRequestsData?.totalRequest?.toString() || '0')
      .setFont(undefined, 'normal');

    doc.text(20, 75, 'Successful Requests:').setFont(undefined, 'normal');
    doc
      .text(70, 75, totalHkRequestsData?.successfulRequest?.toString() || '0')
      .setFont(undefined, 'normal');
    doc.text(20, 80, 'Failed Requests:').setFont(undefined, 'normal');
    doc
      .text(70, 80, totalHkRequestsData?.failedRequest?.toString() || '0')
      .setFont(undefined, 'normal');

    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 85,
      theme: 'striped',
    });

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Housekeeping-Total-Requests.pdf');
  };

  const generateServicesPdf = () => {
    let body = [];
    let header = ['Name', 'Value'];
    let topService = [];
    let topServicesHeader = ['Name', 'Count', 'ART(mins)'];
    if (hkServiceDetails && hkServiceDetails?.categoryPieChartData) {
      let tempData = JSON.parse(hkServiceDetails?.categoryPieChartData);
      body = generatePdfTable(tempData, ['name', 'value']);
      topService = generatePdfTable(hkServiceDetails?.topRequestedServices, [
        'name',
        'count',
        'averageResponseTime',
      ]);
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);

    const titleText = 'HOUSEKEEPING';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);

    const subTitleText = 'Services';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc
      .text(80, 50, moment().format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc
      .text(80, 55, moment(startDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc
      .text(80, 60, moment(endDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 70, 'Total Requests Received:').setFont(undefined, 'normal');
    doc.text(80, 70, hkServiceDetails?.totalRequest.toString()).setFont(undefined, 'bold');
    doc.text(20, 75, 'Avg Response Time (ART):').setFont(undefined, 'normal');
    doc
      .text(80, 75, `${hkServiceDetails?.averageResponseTime.toString()} mins`)
      .setFont(undefined, 'bold');

    doc.text(20, 90, 'Top Requested Services').setFont(undefined, 'bold');
    doc
      .setFont(undefined, 'normal')
      .text(20, 100, 'Total Top Service Requests:')
      .setFont(undefined, 'normal');
    doc.text(80, 100, `${hkServiceDetails?.totalServiceRequest.toString()}`);

    doc.setFont(undefined, 'bold').text(20, 160, 'Categories');
    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [topServicesHeader],
      body: topService,
      startY: 110,
      theme: 'striped',
    });

    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 165,
      theme: 'striped',
    });

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Housekeeping-Service.pdf');
  };

  const handleClose = () => {
    setIsPreview(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const TableData = () => {
    return (
      <TableContainer>
        <Table className='list-table ' aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>Rank</TableCell>
              <TableCell>Service Name</TableCell>
              <TableCell>Requested</TableCell>
              <TableCell>Avg Response Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? hkActivityList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : hkActivityList
            )?.map((user, i) => (
              <TableRow key={i} className='border-white pointer'>
                <TableCell>{user?.rank}</TableCell>
                <TableCell>{user?.serviceName}</TableCell>
                <TableCell>{user?.requestedCount}</TableCell>
                <TableCell>{user?.averageResponseTime}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow className='paginator'>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                count={hkActivityList?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'Items per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    );
  };

  const housekeepingMatrix = [
    {
      title: 'Total Requests',
      subTitle: 'Successful Requests + Failed Requests',
      total: (totalHkRequestsData && totalHkRequestsData.totalRequest) || 0,
    },
    {
      title: 'Successful Requests',
      subTitle: 'Success Count',
      total: (totalHkRequestsData && totalHkRequestsData.successfulRequest) || 0,
    },
    {
      title: 'Failed Requests',
      subTitle: 'API Failure Count',
      total: (totalHkRequestsData && totalHkRequestsData.failedRequest) || 0,
    },
  ];

  return (
    <>
      {showNoData ? (
        <span className='py-2'>
          Unable to generate reports due to third-party integration limitations.
        </span>
      ) : null}
      <div id='Requests' className='d-flex flex-column gap-3'>
        <CardWrapper
          title='Requests'
          hotelName={currentHotelName}
          startDate={startDate}
          showLoader={showLoader}
          showExportButton={true}
          endDate={endDate}
          onClickRefreshBtn={onFetchTotalHkRequestData}
          exportData={generateTotalReservationPdf}
          excelData={generateTotalReservationExportData(
            totalHkRequestsData,
            startDate,
            endDate,
            'hk',
          )}
          showAllForReport={showAllForReport}
          setShowAllForReport={setShowAllForReport}
        >
          <div className='d-flex  flex-wrap p-3'>
            {housekeepingMatrix?.map((summary, index) => (
              <SummaryCardWrapper
                key={index}
                title={summary?.title}
                subTitle={summary?.subTitle}
                total={summary?.total?.toLocaleString()}
              />
            ))}
          </div>

          {reservationChartData?.length > 0 && (
            <WidgetWrapper
              title={'Request Count'}
              isCustom={true}
              // onClickRefreshBtn={onFetchHKServiceData}
              // isInformation={
              //   "Categorizing total number of requests based on category of service request"
              // }
              className={'col pt-0 pb-3 px-3'}
            >
              <div className='row d-flex mt-2'>
                {/* <div className="col analytic-time-period text-nowrap">
                Time Period:
                {` ${moment(startDate).format(statisticsDataKeys?.errorReportDateFormat)} - ${moment(
                  endDate
                ).format(statisticsDataKeys?.errorReportDateFormat)}`}{" "}
              </div> */}

                {reservationChartData?.length > 0 && (
                  <CustomLineChart
                    xAxis={statisticsDataKeys?.date}
                    data={reservationChartData}
                    sliderX={true}
                    color={'#ff9800'}
                    tooltipItems={['Requests']}
                  />
                )}
              </div>
            </WidgetWrapper>
          )}

          <div className='d-flex flex-wrap gap-3 px-3 py-0'>
            <div className='col'>
              <WidgetWrapper
                title={`Requested Services ${selectedCategory}`}
                className='col'
                onClickExpand={() => setIsPreview(true)}
                onClickRefreshBtn={() => {
                  onFetchHKServiceFilterData();
                  onFetchHKActivityListData();
                }}
                isCustom={true}
                // isInformation={
                //   "Most/least requested service in the given time frame"
                // }
                selectedCategory={selectedCategory}
              >
                <div className='analytics-request-service-label'>
                  <p>Top 5 Requested Services</p>
                </div>
                <div className='d-flex justify-content-around mt-4 analytic-top-five-container'>
                  {fetchHKServiceFilter?.topRequestedServices?.slice(0, 5)?.map((img, i) => (
                    <ImageCard
                      title={img?.name}
                      count={i + 1}
                      subTitle1={`Count: ${img?.count?.toLocaleString()}`}
                      //Temporarily hide the Avg Response Time Concept
                      // subTitle2={`ART: ${img.averageResponseTime} mins`}
                      url={
                        (img?.images &&
                          img?.images?.length > 0 &&
                          ASSET_URL + img?.images[0]?.master) ||
                        './assets/img/analytics/hk-no-image.png'
                      }
                    />
                  ))}
                </div>
                <div className='analytics-request-service-label'>
                  <p>Least 5 Requested Services</p>
                </div>
                <div className=' d-flex justify-content-around analytic-top-five-container mt-4'>
                  {fetchHKServiceFilter?.topRequestedServices
                    ?.slice()
                    ?.sort((a, b) => a.count - b.count)
                    ?.slice(0, 5)
                    ?.map((img, i) => (
                      <ImageCard
                        title={img?.name}
                        count={i + 1}
                        subTitle1={`Count: ${img?.count?.toLocaleString()}`}
                        //Temporarily hide the Avg Response Time Concept
                        // subTitle2={`ART: ${img.averageResponseTime} mins`}
                        url={
                          (img?.images &&
                            img?.images?.length > 0 &&
                            ASSET_URL + img?.images[0]?.master) ||
                          './assets/img/analytics/hk-no-image.png'
                        }
                      />
                    ))}
                </div>
                <div className='analytic-breaker-light' />
                <div className='mx-2 d-flex'>
                  <div className='total-booking me-4 ms-1'>
                    <span>{fetchHKServiceFilter?.totalServiceRequest?.toLocaleString()}</span>
                    <span className='total-title ms-1'>Total Service Items Requested</span>
                  </div>
                </div>
              </WidgetWrapper>
            </div>
          </div>
        </CardWrapper>

        <ServiceRequest
          key='ServiceRequest'
          allStatisticsData={totalHkRequestsData}
          showAllForReport={showAllForReport}
          currency={currency}
        />

        {pieChartData?.[0]?.value > 0 || pieChartData?.[1]?.value > 0 ? (
          <div className='col-12'>
            <WidgetWrapper
              title={'Service Categories'}
              subTitle={'Category-Wise Service Request Share'}
              isCustom={true}
              onClickRefreshBtn={onFetchHKServiceData}
              // isInformation={
              //   "Categorizing total number of requests based on category of service request"
              // }
              className={'col p-0 position-relative'}
            >
              <div className='text-center' style={{ height: '20rem' }}>
                <CustomPieChart data={pieChartData} tooltipItems={[formatPieChartTooltip]} />
              </div>
            </WidgetWrapper>
          </div>
        ) : (
          <></>
        )}
        {/* <CardWrapper
          title="Services"
          isInformation={"Services"}
          start={startDate}
          end={endDate}
          onClickRefreshBtn={onFetchHKServiceData}
          exportData={generateServicesPdf}
          excelData={generateReservationExportData(
            hkServiceDetails,
            startDate,
            endDate,
            "hk"
          )}
        > */}
        <div className='d-flex flex-wrap gap-3 p-3'>
          {/* Temporarily hide the Avg Response Time Concept
            <SummaryCardWrapper
              title="Total Requests Received"
              total={(hkServiceDetails && hkServiceDetails?.totalRequest) || 0}
              isInformation={
                "Total number of requests received in the given time frame"
              }
            /> */}

          {/* Temporarily hide the Avg Response Time Concept
          <SummaryCardWrapper
            title="Avg Response Time (ART)"
            total={
              (hkServiceDetails &&
                `${hkServiceDetails.averageResponseTime || 0} mins`) ||
              "0 mins"
            }
          /> */}
        </div>

        {/* </CardWrapper> */}

        {fetchHKServiceFilter &&
          fetchHKServiceFilter?.topRequestedServices?.length > 0 &&
          isPreview && (
            <HouseKeepingPreviewPopup
              viewPreviewStatus={isPreview}
              handleClose={handleClose}
              title='Total Requested Services'
              subTitle1='Top 5 Requested Services'
              subTitle2='Service Activity'
              topAppointment={fetchHKServiceFilter?.topRequestedServices
                ?.slice(0, 5)
                ?.map((item) => {
                  return {
                    ...item,
                    sub1: `Count: ${item?.count}`,
                    img:
                      (item?.images &&
                        item?.images?.length > 0 &&
                        ASSET_URL + item?.images[0]?.master) ||
                      './assets/img/analytics/hk-no-image.png',
                  };
                })}
              count={fetchHKServiceFilter?.totalServiceRequest}
              revenue={'NA'}
              subTitle3='Least 5 Requested Services'
              leastAppointment={fetchHKServiceFilter?.topRequestedServices
                ?.slice()
                ?.sort((a, b) => a.count - b.count)
                ?.slice(0, 5)
                ?.map((item) => {
                  return {
                    ...item,
                    sub1: `Count: ${item?.count?.toLocaleString()}`,
                    img:
                      (item?.images &&
                        item?.images?.length > 0 &&
                        ASSET_URL + item?.images[0]?.master) ||
                      './assets/img/analytics/hk-no-image.png',
                  };
                })}
            >
              {<TableData />}
            </HouseKeepingPreviewPopup>
          )}
      </div>
    </>
  );
};

export default Housekeeping;
